import dayjs from 'dayjs';

const SEVEN_DAYS = 7;
const THIRTY_DAYS = 30;

const RETENTION_PREFIX_7D = `${SEVEN_DAYS}d/`;
const RETENTION_PREFIX_30D = `${THIRTY_DAYS}d/`;

export type TRetentionDays = typeof SEVEN_DAYS | typeof THIRTY_DAYS;

// Parses reportBucketPrefixKey (e.g. 7d/{jobId} or 30d/{jobId}) to get retention days.
export function getRetentionDaysFromPrefix(
  reportBucketPrefixKey: string | undefined
): TRetentionDays | null {
  if (!reportBucketPrefixKey || typeof reportBucketPrefixKey !== 'string') return null;
  if (reportBucketPrefixKey.startsWith(RETENTION_PREFIX_7D)) return SEVEN_DAYS;
  if (reportBucketPrefixKey.startsWith(RETENTION_PREFIX_30D)) return THIRTY_DAYS;
  return null;
}

// Returns clear text for recording storage time limits (DOD: "Clear information on recording storage time limits").
export function getReportStorageRetentionText(
  retentionDays: number,
  completionTime: string
): string {
  const completion = dayjs(completionTime);
  if (!completion.isValid()) {
    return `Recordings and logs are stored for ${retentionDays} days after scan completion.`;
  }

  const deleteDate = completion.add(retentionDays, 'day');
  const formattedDate = deleteDate.format('DD MMM YYYY');
  const isPast = dayjs().isAfter(deleteDate);

  return isPast
    ? `${retentionDays}-day retention: recordings and logs were deleted on ${formattedDate}.`
    : `${retentionDays}-day retention: recordings and logs will be deleted on ${formattedDate}.`;
}
